import script from "./LessonPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonPage.vue?vue&type=script&setup=true&lang=js"

import "./LessonPage.vue?vue&type=style&index=0&id=4116723a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4116723a"]])

export default __exports__